// @flow
import type { Element } from 'react';

import React from 'react';
import { Form } from 'reactstrap';
import {
  COMPONENT_ID,
  UNIT,
  NAME,
  UNIT_QUANTITY,
  SHORT_NAME,
  AUTHOR,
  DESCRIPTION,
  DATA_QUALITY,
  DATA_RELEVANCE,
  DOCUMENTATION,
  RATIONALITY,
} from '@hbrisk/sp3-risk-model-support/components/app/attributes/names/index.js';
import { fieldsByName } from '@hbrisk/sp3-risk-model-support/components/form/fields/index.js';

import {
  Col,
  Field,
  FormGroup,
  Fieldset,
} from '#components/pages/Components/support/form/index.js';
import NextButton from '../support/buttons/NextButton.jsx';

type Props = {
  onNext: () => {},
  readOnly?: boolean,
};

const General = ({ onNext, readOnly = false }: Props): Element<'div'> => (
  <Form noValidate>
    <Fieldset>
      <legend>General</legend>
      <FormGroup fields={[COMPONENT_ID, AUTHOR]} row>
        <Col lg="6" field={COMPONENT_ID}>
          <Field field={fieldsByName[COMPONENT_ID]} readOnly />
        </Col>
        <Col lg="6">
          <Field field={fieldsByName[AUTHOR]} readOnly={readOnly} />
        </Col>
      </FormGroup>
      <FormGroup fields={[NAME]}>
        <Field field={fieldsByName[NAME]} readOnly={readOnly} />
      </FormGroup>
      <FormGroup fields={[SHORT_NAME]}>
        <Field field={fieldsByName[SHORT_NAME]} readOnly={readOnly} />
      </FormGroup>
      <FormGroup fields={[DESCRIPTION]}>
        <Field field={fieldsByName[DESCRIPTION]} readOnly={readOnly} />
      </FormGroup>
      <FormGroup fields={[UNIT, UNIT_QUANTITY]} row>
        <Col lg="6">
          <Field field={fieldsByName[UNIT]} readOnly={readOnly} />
        </Col>
        <Col lg="6">
          <Field field={fieldsByName[UNIT_QUANTITY]} readOnly={readOnly} />
        </Col>
      </FormGroup>
    </Fieldset>
    <Fieldset>
      <legend>Ratings</legend>
      <FormGroup fields={[DATA_QUALITY]} row>
        <Col lg="6">
          <Field field={fieldsByName[DATA_QUALITY]} readOnly={readOnly} />
        </Col>
      </FormGroup>
      <FormGroup fields={[DATA_RELEVANCE]} row>
        <Col lg="6">
          <Field field={fieldsByName[DATA_RELEVANCE]} readOnly={readOnly} />
        </Col>
      </FormGroup>
      <FormGroup fields={[DOCUMENTATION]} row>
        <Col lg="6">
          <Field field={fieldsByName[DOCUMENTATION]} readOnly={readOnly} />
        </Col>
      </FormGroup>
      <FormGroup fields={[RATIONALITY]} row>
        <Col lg="6">
          <Field field={fieldsByName[RATIONALITY]} readOnly={readOnly} />
        </Col>
      </FormGroup>
    </Fieldset>
    <NextButton onClick={onNext} />
  </Form>
);

export default General;
